import { Button } from '@progress/kendo-react-buttons';
import type { SamplerUser } from '../../services/api.types.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { DashboardTileHeader } from '../../components/dashboard/dashboard-tile-header.tsx';
import { DashboardTileContent } from '../../components/dashboard/dashboard-tile-content.tsx';
import { ListView } from '../../components/list/list-view.tsx';
import type { ActiveSamplersTileProps } from './active-samplers-tile.types.ts';
import type { ListViewRenderProps } from '../../components/list/list-view.types.ts';
import { ListViewItem } from '../../components/list/list-view-item.tsx';
import { ListViewItemText } from '../../components/list/list-view-item-text.tsx';
import { ListViewItemSeparator } from '../../components/list/list-view-item-separator.tsx';
import styles from './active-samplers-tile.module.scss';

export function ActiveSamplersTile({ data }: ActiveSamplersTileProps) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/sampler-management');
  };

  const renderSamplerItems = ({ dataItem }: ListViewRenderProps<SamplerUser>) => {
    return (
      <ListViewItem className={styles.listItem}>
        <ListViewItemText flex={3}>
          <strong>{dataItem.username}</strong>
        </ListViewItemText>
        <ListViewItemSeparator />
        <ListViewItemText flex={2}>
          <strong>Forename:&nbsp;</strong>
          {dataItem.forename}
        </ListViewItemText>
        <ListViewItemSeparator />
        <ListViewItemText flex={2}>
          <strong>Surname:&nbsp;</strong>
          {dataItem.surname}
        </ListViewItemText>
      </ListViewItem>
    );
  };

  return (
    <>
      <DashboardTileHeader>
        Active Samplers
        <Button onClick={handleNavigate}>
          <FontAwesomeIcon icon={faArrowRight} size={'sm'} />
        </Button>
      </DashboardTileHeader>
      <DashboardTileContent className={styles.content}>
        <ListView<SamplerUser> className={styles.list} data={data} item={renderSamplerItems} />
      </DashboardTileContent>
    </>
  );
}
